export default "__VITE_ASSET__kxR2PQaN__"